import { React } from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { createTheme, ThemeProvider } from '@mui/material/styles'

import "./App.scss";
import * as serviceWorker from "./serviceWorker";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0e395d",
      light: "#409ba0",
    },
    secondary: {
      main: "#409ba0",
      dark: "#0e395d",
      light: "#14e3ed",
      alphalight: "#14e3ed36",
    },
    background: {
      default: "#0e395d",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
);

serviceWorker.unregister();
